import { paths } from 'src/routes/paths';

import { CONFIG } from './environments/environment';

// API
// ----------------------------------------------------------------------

// export const HOST_API = CONFIG.VITE_HOST_API;
export const ASSETS_API = 'none'; // CONFIG.VITE_ASSETS_API;

// Dummy User
export const dummyAccount = CONFIG.VITE_MAIN_TEST_ACCOUNT_NUMBER;
export const FIREBASE_API = {
  apiKey: CONFIG.VITE_FIREBASE_API_KEY,
  authDomain: CONFIG.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: CONFIG.VITE_FIREBASE_PROJECT_ID,
  storageBucket: CONFIG.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: CONFIG.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: CONFIG.VITE_FIREBASE_APPID,
  measurementId: CONFIG.VITE_FIREBASE_MEASUREMENT_ID,
};

export const FIREBASE_REALTIME_DB_URL = CONFIG.VITE_FIREBASE_REALTIME_DB_URL;
export const STRIPE_PUBLISHABLE_KEY = CONFIG.VITE_STRIPE_PUBLISHABLE_KEY;
export const PAYMENT_LINK_BASE_URL = CONFIG.VITE_APP_DOMAINS.POINTPAY_PUBLIC;
export const POINTPAY_PUBLIC_URL = CONFIG.VITE_APP_DOMAINS.POINTPAY_PUBLIC;

// ROOT PATH AFTER LOGIN SUCCESSFUL

export const { isLocal, isStaging, isMock, isProd, isWeb, isMobile } = CONFIG.VITE_CURRENT_ENV;

export const isDev = CONFIG.VITE_CURRENT_ENV.isDev || CONFIG.VITE_CURRENT_ENV.isLocal;
export const DEFAULT_PRODUCT_URL =
  'https://pointcraft1.b-cdn.net/Pointcraft%20App%20Assets/DefaultMealImage.svg';

export const formattedReceiptSmsMessage = ({
  saleId,
  businessName,
  totalAmount,
}: {
  saleId: string;
  businessName: string;
  totalAmount: string;
}) => {
  let domainByEnv = 'https://receipts.pointcraft.io';
  switch (CONFIG.environment.toLowerCase()) {
    case 'staging':
      domainByEnv = 'https://staging-receipts.pointcraft.io';
      break;
    case 'production':
      domainByEnv = 'https://receipts.pointcraft.io';
      break;
    case 'local':
    case 'dev':
      domainByEnv = 'https://dev-receipts.pointcraft.io';
      break;
    default:
      domainByEnv = 'https://receipts.pointcraft.io';
      break;
  }

  const receiptUrl = `${domainByEnv}/${saleId}`;
  const fullMessage = `Pointcraft: Thank you for your purchase from ${businessName}. You can view your receipt at ${receiptUrl}.`;

  if (fullMessage.length <= 160) {
    return fullMessage;
  }

  // Shortened message - prioritize the link
  return `Your receipt is ready: ${receiptUrl}`;
};

export const formattedPaymentLinkSmsMessage = ({
  businessName,
  totalAmount,
  paymentLinkUrl,
}: {
  businessName: string;
  totalAmount: string;
  paymentLinkUrl: string;
}) => {
  const fullMessage = `${businessName} has sent you a payment request for ${totalAmount}. Pay securely at ${paymentLinkUrl}`;

  if (fullMessage.length <= 160) {
    return fullMessage;
  }

  // Shortened message - prioritize the link
  return `Payment request for ${totalAmount}: ${paymentLinkUrl}`;
};

export const SECRET_KEY_LOCAL_ADMIN = 'JBSWY3DPEHPK3PXP';
export const DEBUG_ADMIN_STATIC_CODE = '456789';

export const PLATFORM_INFO = {
  CUSTOMER_SERVICE_PHONE: '+1-844-639-8729',
  TECHNICAL_SUPPORT_PHONE: '+1-612-473-5556',
  SUPPORT_EMAIL: 'support@point-craft.com',
  BASE_EMAIL: 'info@point-craft.com',
  WEBSITE_URL: 'https://point-craft.com',
  SUPPORT_URL: 'https://point-craft.com/contact',
  BASE_WEBSITE_URL: 'www.point-craft.com',
  BASE_IO_WEBSITE_URL: 'www.pointcraft.io',
  COPYRIGHT: '© 2025 PointCraft. All rights reserved.',
  LEGAL_NOTICE: 'PointCraft is a registered trademark of PointCraft, Inc.',
  ADDRESS: '3055 Old Hwy 8, Suite 109, Minneapolis, MN, 55418-2595',
  ADDRESS_OBJECT: {
    street1: '3055 Old Hwy 8',
    street2: 'Suite 109',
    city: 'Minneapolis',
    state: 'MN',
    zip: '55418-2595',
    country: 'US',
  },
};

export enum SiteIdEnum {
  PointOfSale = 'point_of_sale',
  PointPay = 'point_pay',
  PointPayPublic = 'point_pay_public',
  SultaniMarketplace = 'sultani_marketplace',
  Manager = 'manager',
}

// Priority: env var > config file > default
export const SITE_ID: SiteIdEnum =
  (import.meta.env.VITE_SITE_ID as SiteIdEnum) ||
  (CONFIG.VITE_SITE_ID as SiteIdEnum) ||
  SiteIdEnum.PointOfSale;

export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
